<app-dropdown
    [options]="options"
    [valueFormControl]="valueFormControl"
    [fieldPlaceholder]="'export-creation.form.selectInterval.placeholder' | translate"
></app-dropdown>
